import type { Theme } from '@mui/material';

const extralight = 200;
// const light = 300;
const regular = 400;
const medium = 500;
const bold = 700;

const typography = (
  primaryFontFamily: string,
  secondaryFontFamily: string
): Theme['typography'] => {
  const fontFamily =
    typeof primaryFontFamily === 'undefined' || primaryFontFamily === ''
      ? typeof secondaryFontFamily === 'undefined' || secondaryFontFamily === ''
        ? [
            '"Helvetica Now Text"',
            'Matter',
            'Inter',
            'sans-serif',
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
          ].join(',')
        : secondaryFontFamily
      : primaryFontFamily;

  return {
    fontFamily,
    fontSize: 14,
    h1: {
      fontSize: '60px',
      fontWeight: extralight,
      lineHeight: '64px',
    },
    h2: {
      fontSize: '20px',
      fontWeight: regular,
      lineHeight: '24px',
    },
    h3: {
      fontSize: '16px',
      fontFamily: secondaryFontFamily || fontFamily,
      fontWeight: medium,
      lineHeight: '24px',
    },
    h4: {
      fontSize: '13px',
      fontWeight: medium,
      lineHeight: '20px',
    },
    h5: {
      fontSize: '1.125rem',
      fontWeight: medium,
      lineHeight: 1.5556,
    },
    h6: {
      fontSize: '0.9375rem',
      fontWeight: medium,
      lineHeight: 1.46667,
    },
    // Label
    subtitle1: {
      fontSize: '13px',
      lineHeight: '20px',
      fontWeight: regular,
    },
    // Tiny Label
    subtitle2: {
      fontSize: '12px',
      lineHeight: '16px',
      fontWeight: regular,
    },
    // Paragraph
    body1: {
      fontSize: '13px',
      lineHeight: '20px',
      fontWeight: regular,
    },
    // Tiny Paragraph
    body2: {
      fontSize: '12px',
      lineHeight: '16px',
      fontWeight: regular,
    },
    button: {
      fontSize: '13px',
      lineHeight: '20px',
      fontWeight: medium,
      textTransform: 'none',
    },
    caption: {
      fontSize: '0.8125rem',
      lineHeight: 1.3846154,
      letterSpacing: '0.4px',
    },
    // Table titles
    overline: {
      fontSize: '11px',
      lineHeight: '16px',
      fontWeight: regular,
    },
    // Label Medium
    subtitle1Strong: {
      fontSize: '13px',
      lineHeight: '20px',
      fontWeight: medium,
    },
    // Tiny Label Medium
    subtitle2Strong: {
      fontSize: '12px',
      lineHeight: '16px',
      fontWeight: medium,
    },
    // Special title. The design specifies Neutra Text Bold Italic Alt, which the
    // app does not ship; the primary family is synthesised to bold italic until
    // the face is licensed and added to public/statics/fonts.
    specialTitle: {
      fontSize: '17px',
      lineHeight: '20px',
      fontWeight: bold,
      fontStyle: 'italic',
    },
    chat: {
      fontSize: '14px',
      fontFamily: secondaryFontFamily || fontFamily,
      lineHeight: '20px',
      fontWeight: regular,
    },
    chatStrong: {
      fontSize: '14px',
      fontFamily: secondaryFontFamily || fontFamily,
      lineHeight: '20px',
      fontWeight: medium,
    },
    fontWeightBold: 700,
    fontWeightLight: 300,
    fontWeightMedium: 500,
    fontWeightRegular: 400,
    htmlFontSize: 14,
    pxToRem: (size: number) => `${size / 14}rem`,
  };
};

export { typography };
